export default "__VITE_ASSET__DXpp02hP__"